export const createCn = (baseClass: string, classes: Record<string, string>) => {
  return (
    el?: string,
    mods: Record<string, boolean> = {},
    extra: string[] = []
  ) => {
    const element = el ? `${baseClass}__${el}` : baseClass

    const modClasses = Object.entries(mods)
      .filter(([_, value]) => value)
      .map(([key]) => `${element}--${key}`)

    const extraClasses = extra.map(e =>
      classes[`${baseClass}__${e}`] || `${baseClass}__${e}`
    )

    return [
      classes[element],
      ...modClasses.map(m => classes[m] || m),
      ...extraClasses,
    ]
      .filter(Boolean)
      .join(' ')
  }
}
